/* global xfiveSentryIntegrationData */

import * as SentryBrowser from '@sentry/browser';

class Sentry {

  constructor() {
    this.data = xfiveSentryIntegrationData;

    if (this.data.isLocalhost) {
      return;
    }

    this.init();
  }

  init() {
    SentryBrowser.onLoad(() => {
      if (this.data.config?.tracesSampleRate) {
        this.data.config = {
          integrations: [SentryBrowser.browserTracingIntegration()],
          ...this.data.config,
        };
      }

      SentryBrowser.init(this.data.config);
    });
  }
}

new Sentry();
